import React, {PropTypes, Component} from 'react';
import { get, isEmpty, isEqual, isNil, keyBy, orderBy } from 'lodash';
import { getApplicantAssessmentTests } from '../../../redux/actionCreators/async';

function AssessmentScore(props) {

  const { test } = props;
  const rawScore = isNil(test.rawScore) ? '' : test.rawScore;
  const proficiency = isNil(test.result) ? '( N/A )' : test.result;
  const percentile = isNil(test.percentile) ? '' : test.percentile;
  const percentage = (test.percentage) ? (`( ${(test.rawScore || 0) * 100 / (test.totalQuestions || 1)}% )`) : '( N/A )';
  const rawScoreClass = (test.passingScore) ?
    ((isNil(test.rawScore) || test.rawScore < test.passingScore) ? 'notgood' : '') :
    (test.result === 'Not Proficient' || test.result === 'Beginner' || test.result === 'Foundational' || test.result === 'Intermediate') ? 'notgood' : ((isNil(test.result)) ? 'na' : '')
  ;

  if (isNil(test.passingScore)) {
    return (
      <div className='data'>
        <span className={`user ${rawScoreClass}`}>{proficiency}</span>
      </div>
    );
  }

  return (
    <div className='data'>
        <span className={`user ${rawScoreClass}`}>{rawScore}</span>
        <span className='general'>{percentage}</span>
        <span className='percentage'>{percentile}</span>
    </div>
  );
}

AssessmentScore.propTypes = {
  test  : PropTypes.object.isRequired
};

function AssessmentRow(props) {

  const { test } = props;
  let minimumRequirement = (test.passingScore) ?
    `Raw score should be ${test.passingScore} and above.` :
    'Proficient (14 and above), but a score of 13 might be acceptable.'
  ;

  if (test.result === 'Beginner' || test.result === 'Foundational' || test.result === 'Intermediate' || test.result === 'Skilled' || test.result === 'Advanced') {
    minimumRequirement = 'Skilled (13 and above), but a score of 12 might be acceptable.';
  }

  return (
    <div key={test.id} className='assessments-skills-evaluation'>
      <div className='title'>
        {test.name}
      </div>
      <AssessmentScore test={test} />
      <div className='required-score'>
        {minimumRequirement}
      </div>
    </div>
  );

}

AssessmentRow.propTypes = {
  test      : PropTypes.object.isRequired
};

export default class AssessmentsTable extends Component {
  static propTypes = {
    tests     : PropTypes.array.isRequired,
    applicant : PropTypes.object.isRequired,
    dispatch  : PropTypes.func.isRequired
  }

  constructor(props) {
    super(props);

    this.state = {
      tests : {}
    };
  }

  componentWillMount() {
    if (!isEmpty(this.props.applicant)) {
      this.refreshAssessments(this.props.applicant);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.applicant && !isEqual(nextProps.applicant, this.props.applicant)) {
      this.refreshAssessments(nextProps.applicant);
    }
  }

  refreshAssessments(applicant) {

    const { dispatch } = this.props;

    if (applicant) {
      dispatch(
        getApplicantAssessmentTests(get(applicant, 'profile.id'), (err, assessmentTests) => {
          if (err) {
            return console.error(err);
          }

          const tests = keyBy(assessmentTests, 'id');
          this.setState(Object.assign({}, this.state, {tests}));
        })
      );
    }

  }

  renderScript(props) {

    if (props.script) {

      return (
        <div className='speaking-callout'>
          Now, I would like to review your assessment scores.?
        </div>
      );

    }

  }

  render() {

    const {
      tests
    } = this.state;

    const testData = orderBy(tests, ['typeId', 'name'], ['asc']);

    return (
      <div className='expanded-accordion-content explanation-of-wahve'>
        {
          this.renderScript(this.props)
        }
        <div className='assessments-skills-list'>
        {
          testData.map(test =>
            <AssessmentRow test={test}/>
          )
        }
        </div>
      </div>
    );

  }

}



// WEBPACK FOOTER //
// ./shared/react/admin/Applicant/AssessmentsTable.js